import { OPEN_DRAWER, CLOSE_DRAWER } from 'Store/constants';
import { SHOW_OCCUPATION_POPUP } from '../constants';

export const openDrawer = payload => {
  return {
    type: OPEN_DRAWER,
    payload: payload,
  };
};

export const closeDrawer = () => {
  return {
    type: CLOSE_DRAWER,
  };
};

export const toggleOccupationPopup = payload => {
  
  return {
    payload: payload,
    type: SHOW_OCCUPATION_POPUP,
  };
};
